import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, BrandS } from '@sorare/core/src/atoms/typography';
import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { RewardConfigImage } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigImage';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import craftingCard from '../assets/crafting-card.webp';

const Root = styled.div`
  position: relative;
  & > * {
    height: 100%;
  }
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: minmax(180px, 1fr) 1fr;
  column-gap: var(--double-unit);
  padding: var(--double-unit) var(--double-unit) 0;
  height: 100%;
  width: 100%;
  align-items: flex-end;

  @media ${tabletAndAbove} {
    column-gap: calc(5 * var(--unit));
  }
`;

const LeftPart = styled(Vertical).attrs({ gap: 0, center: true })`
  justify-content: flex-end;
`;

const CraftingCard = styled.img`
  max-width: 120%;
`;

const TextWrapper = styled(Vertical)`
  align-self: center;
`;
const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

type Props = {
  title?: ReactNode;
};
export const Craft = ({ title }: Props) => {
  return (
    <Root>
      <Bezel borderColor="rgba(var(--c-rgb-limited), 0.3)">
        <StyledTextureBackground
          background="wave2"
          mode="dark"
          color={['var(--c-limited-secondary)', 'var(--c-limited)']}
          withDots
        />
        <StyledNeonEdge
          color="var(--c-limited)"
          showNeon="always"
          showHalo="always"
        />
        <Content>
          <LeftPart>
            <Horizontal>
              <RewardConfigImage
                anyRewardConfig={{
                  __typename: 'CardShardRewardConfig',
                  configRarity: 'limited',
                  id: '1',
                }}
              />
              <BrandS>-1000</BrandS>
            </Horizontal>
            <CraftingCard src={craftingCard} alt="" />
          </LeftPart>
          <TextWrapper>
            {title || (
              <FormattedMessage
                id="IntroducingRoadToPro.craft.title"
                defaultMessage="<em>Craft</em><label>your first Limited Card</label>"
                values={{
                  em: chunks => <BrandM>{chunks}</BrandM>,
                  label: chunks => (
                    <BodyM color="var(--c-nd-600)">{chunks}</BodyM>
                  ),
                }}
              />
            )}
          </TextWrapper>
        </Content>
      </Bezel>
    </Root>
  );
};
